import { PropsWithChildren } from 'react';
import styles from './PagedDialog.module.scss';

export const Footer = (props: PropsWithChildren<unknown>) => {
	const { children } = props;
	return (
		<div className={styles.footer}>
			{children}
		</div>
	);
}
Footer.displayName = 'Footer';
